// 수강권 수정 화면(ProfileView)이 PUT /v1/admin/memberships/{id}로 보낼 본문.
// 모달에 채운 값(original)과 비교해 관리자가 바꾼 칸만 보낸다. original은 회원 화면이 마지막으로 읽은 수강권 목록의 값이다
// (화면을 열 때, 활성/전체 탭, 그 화면의 쓰기 뒤에 읽고, 모달을 열 때는 다시 읽지 않는다). 서버는 보낸 칸만 쓰고(ApplyAdminEdit)
// 나머지는 잠근 지금 값 그대로 두므로, 그 목록을 읽은 뒤 R4 보상 적용·회원 예약·취소·휴회가 바꾼 남은 횟수·종료일·상태를
// 화면의 옛 값으로 되돌리지 않는다. 관리자가 바꾼 칸은 적은 값이 그대로 저장된다(같은 칸이 목록을 읽은 뒤 바뀌어도 막지 않음,
// DECISIONS "R4 사장님 검토 대기").
// 기간권(total_count -1)은 남은 횟수를 보내지 않는다(예전과 같음). 바꾼 칸이 없으면 빈 본문이다.
// 수강권 특이사항(note, 2026-10-25)은 앞뒤 공백을 뗀 값으로 견주고 보낸다(공백만 다르면 보내지 않음, 지우면 "").
// node 단위 테스트가 불러오도록 import 없이 둔다(scripts/test-membership-edit.mjs).
// 수강권 특이사항 최대 글자 수(서버 models.MembershipNoteMaxRunes와 같음). 추가·수정 입력칸의 maxlength
export const MEMBERSHIP_NOTE_MAX = 500;

export function membershipEditBody(original, form) {
  const body = {};
  if (form.status !== original.status) body.status = form.status;
  if (form.start_date !== original.start_date)
    body.start_date = form.start_date;
  if (form.end_date !== original.end_date) body.end_date = form.end_date;
  if (
    original.total_count !== -1 &&
    form.remaining_count !== original.remaining_count
  ) {
    body.remaining_count = form.remaining_count;
  }
  const note = (form.note || "").trim();
  if (note !== (original.note || "").trim()) body.note = note;
  return body;
}
